"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const acneblemishesskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-acneblemishesskin` : '') + (description ? ` desc-acneblemishesskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-acneblemishesskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-acneblemishesskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.24 18.42a.75.75 0 1 1 .5 1.42c-.34.12-.71.2-1.1.26a8.87 8.87 0 0 1-3.6-.26.75.75 0 0 1 .5-1.42c.21.08.5.15.82.2a7.4 7.4 0 0 0 2.06 0l.23-.05c.23-.04.43-.09.6-.15Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.2 17.23a.9.9 0 1 1 1.76.4.9.9 0 0 1-1.75-.4Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.49 17a.9.9 0 1 1 1.68.64.9.9 0 0 1-1.68-.64Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.66 16.88a.9.9 0 1 1 1.68.64.9.9 0 0 1-1.68-.64Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.13 15.9a.75.75 0 0 1 .68 1.33l-.07.04h-.01l-.03.02-.07.03a2.54 2.54 0 0 1-1.1.28 2.54 2.54 0 0 1-1.1-.28l-.08-.03-.03-.02a.75.75 0 0 1 .67-1.34l.05.02.16.07a1 1 0 0 0 .33.08 1 1 0 0 0 .32-.08l.16-.07.04-.02h.01l.07-.03Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.78 15.75a.9.9 0 1 1 1.76.4.9.9 0 0 1-1.76-.4Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.44 15.21a.9.9 0 1 1 1.75.4.9.9 0 0 1-1.75-.4Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.52 15a.9.9 0 1 1 1.68.64.9.9 0 0 1-1.68-.64Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.62 12.35a.75.75 0 0 1 .83 1.25l-.07.05h-.01a2.46 2.46 0 0 1-.16.1l-.42.19c-.31.13-.8.31-1.29.31a3.6 3.6 0 0 1-1.29-.31 5.84 5.84 0 0 1-.57-.28l-.01-.01h-.01a.75.75 0 0 1 .76-1.3l.03.02.08.04.31.15c.27.12.53.19.7.19.17 0 .43-.07.7-.19a4.3 4.3 0 0 0 .4-.2h.02Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.62 12.35a.75.75 0 0 1 .83 1.25l-.07.05h-.01a2.46 2.46 0 0 1-.16.1l-.42.19c-.31.13-.8.31-1.29.31a3.6 3.6 0 0 1-1.29-.31 5.85 5.85 0 0 1-.57-.28l-.02-.01a.75.75 0 0 1 .76-1.3l.03.02.08.04.31.15c.27.12.53.19.7.19.17 0 .43-.07.7-.19a4.3 4.3 0 0 0 .4-.2h.02Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.7 9.6a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.7 8.4a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85.76A7.82 7.82 0 0 1 12.6.45c.65.19 1.23.5 1.67.95 2.72-.01 4.99 1 6.5 2.78 1.56 1.85 2.23 4.46 1.8 7.4-.35 2.51-1.03 4.99-2.74 6.85a7.82 7.82 0 0 1-1.78 2.97 7.8 7.8 0 0 1-8.31 1.92l-.37-.15a7.81 7.81 0 0 1-3.98-3.8 10.84 10.84 0 0 1-4.07-8.35v-.53C1.4 5.09 4.59 1.94 7.85.76Zm4.4 5.78-.27.01a6.32 6.32 0 0 0-5.87 6.32v2.87a6.33 6.33 0 0 0 8.77 6.05l.29-.13a6.3 6.3 0 0 0 3.55-5.92v-.04l.04-2.83a6.35 6.35 0 0 0-6.32-6.34h-.18Zm-.08-4.65a6.34 6.34 0 0 0-3.8.28c-2.74 1-5.49 3.63-5.56 8.35V11a9.35 9.35 0 0 0 1.8 5.44 7.86 7.86 0 0 1 0-.72v-2.84a7.85 7.85 0 0 1 7.54-7.83 1.6 1.6 0 0 0 1.43-1.6 1.38 1.38 0 0 0-.29-.87c-.23-.3-.6-.53-1.12-.68Zm2.87 1.04a3.11 3.11 0 0 1-.58 2.37 7.83 7.83 0 0 1 5.8 7.57v.02l-.03 2c.41-1.05.67-2.24.85-3.52.38-2.6-.23-4.75-1.47-6.22a6.5 6.5 0 0 0-4.57-2.22Z",
    fill: "#232323"
  }));
};
var _default = exports.default = acneblemishesskin;